import { Component } from "@angular/core";
import { SplashScreen } from "@capacitor/splash-screen";
import { EventsService } from "./services/event/event.service";
import { Platform } from "@ionic/angular";
import { ConfigService } from "./services/config/config.service";
import { NavigationEnd, NavigationStart, Router } from "@angular/router";
import { SidemenuService } from "./services/lobby/sidemenu.service";
import { WebcontentService } from "./services/webcontent/webcontent.service";
import { RedirectService } from "./services/redirect/redirect.service";
import { Navigator } from 'src/app/components/menu/navigator';
import { checkRedirectLoggedInRoutesName, checkRedirectLoggedOutRoutesName } from "./components/menu/factory";
import { filter, pluck, tap } from "rxjs/operators";
import { SeoService } from "./services/seo/seo.service";
declare var UserAgent: any


@Component({
  selector: "app-root",
  templateUrl: "app.component.html",
  styleUrls: ["app.component.scss"],
})
export class AppComponent {
  public showLobby: boolean = true;
  public suspendNotifications: boolean = false;
  public isAuthenticated: boolean = false;
  public isMobileApp = false;
  public showSiteHeader: boolean = true;
  public showBottomMenu = false;

  constructor(
    private events: EventsService,
    private platform: Platform,
    private config: ConfigService,
    private router: Router,
    public webcontentService: WebcontentService,
    public redirectService: RedirectService,
    public navigator: Navigator,
    private seoService: SeoService,
    private sidemenuService: SidemenuService
  ) {
    this.isMobileApp = this.platform.is('capacitor');

    //-----------Browser back/forward button logic start------------
    if (!this.isMobileApp) {
      router.events.forEach((event) => {
        if (event instanceof NavigationStart) {
          if (event.navigationTrigger === 'popstate') {
            let browserURLPath = event.url;
            let authCheckForUser: boolean;
            if (localStorage.getItem('userSession.sessionToken') !== null) {
              authCheckForUser = true;
            } else {
              authCheckForUser = false;
            }

            //Unhighlight keywords highlight on Browser back button
            setTimeout(() => {
              if (document.getElementsByClassName("keywords-isactive")) {
                let ActiveKeyword = document.getElementsByClassName("keywords-isactive")[0] as HTMLElement;
                if (!!ActiveKeyword && ActiveKeyword.classList.contains('keywords-isactive')) ActiveKeyword.classList.remove('keywords-isactive');
              }
            }, 200);

            //Casino path logic
            if (browserURLPath != '/' && browserURLPath.indexOf('casino') > -1) {
              //Adjust Keyword selection simplest way
              let checkKeyword: any = document.getElementsByClassName("keywords-isactive")[0];
              if (checkKeyword) {
                if (checkKeyword.innerText == 'Promotions' || checkKeyword.innerText == 'Live dealer' || checkKeyword.innerText == 'Live Dealer' || checkKeyword.innerText == 'Rewards' || checkKeyword.innerText == 'Free Spin') {
                  this.redirectService.updateDefaultKeywordSelection();
                }
              }
              this.navigator.dismissAll();
              return this.router.navigateByUrl(browserURLPath);
            }
            //WordPress page logic
            let urlParts = browserURLPath.split("/");
            if (browserURLPath != '/' && urlParts[1] == 'c') {
              if (typeof urlParts[2] === 'string') {
                this.webcontentService.updateExternalLink(urlParts[2]);
                return this.navigator.toWebview(true, urlParts[2]);
              }
            }
            //LiveDealer path logic
            if (browserURLPath != '/' && browserURLPath.indexOf('livedealer') > -1) {
              return this.redirectService.browserReloadActions('livedealer');
            }
            //All other modal component logic based on user authentication
            if (browserURLPath != "/") {
              let cleanPath = browserURLPath.substring(1);
              let pageToLoad;
              if (authCheckForUser) {
                pageToLoad = checkRedirectLoggedInRoutesName(cleanPath);
                if (!!pageToLoad) return this.navigator.navigateTo(pageToLoad);
                return this.router.navigate(['/casino'], { skipLocationChange: false });
              } else {
                pageToLoad = checkRedirectLoggedOutRoutesName(cleanPath);
                if (!!pageToLoad) return this.navigator.navigateTo(pageToLoad);
                return this.router.navigate(['/casino'], { skipLocationChange: false });
              }
            }
          }

        }
      });
    }
    //-----------Browser back/forward button logic end------------
  }

  ngOnInit() {
    this.setupSeoMetaData();

    if (
      this.config.getDeafaultRoute() === "/" ||
      this.config.getDeafaultRoute() === "landing"
    ) {
      this.showSiteHeader = false;
    }

    this.router.events.subscribe(() => {
      if (this.isMobileApp) {
        if (this.router.url == '/' || this.router.url == '/landing') {
          this.showBottomMenu = false;
          this.showSiteHeader = false;
        } else {
          this.showBottomMenu = true;
          this.showSiteHeader = true;
        }
      }
    });

    this.config.isLoaded().then(() => {
      setTimeout(() => {
        SplashScreen.hide();
      }, 3000);
    })

    this.events.subscribe("event:login", (data) => {
      if (data) {
        this.isAuthenticated = true;
      }
    });
    this.events.subscribe("event:bottommenu:hide", () => {
      this.showBottomMenu = false;
      this.showSiteHeader = false;
    });
    this.events.subscribe("event:bottommenu:show", () => {
      this.showBottomMenu = true;
      this.showSiteHeader = true;
    });

    this.events.subscribe("event:lobby:hide", () => {
      this.showLobby = false;
      this.showSiteHeader = false;
    });

    this.events.subscribe("event:lobby:show", () => {
      this.showLobby = true;
      this.showSiteHeader = true;
    });

    this.events.subscribe("event:notification:suspend", () => {
      this.suspendNotifications = true;
    });

    this.events.subscribe("event:notification:resume", () => {
      this.suspendNotifications = false;
    });
    this.setUserAgentForiPad();
  }

  async setUserAgentForiPad() {
    const isIPad = this.platform.is('capacitor') && this.platform.is('ipad');
    const userAgentEnabled = this.config.getConfig()["FEATURE_IPAD_USERAGENT_DISABLED"] == "1" ? true : false;
    if (isIPad && !userAgentEnabled && UserAgent) {
      try {
        const userAgent = 'Mozilla/5.0 (iPad; CPU iPad OS 17 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/13.1 Mobile/15E148 Safari/604.1'
        UserAgent.set(userAgent);
      } catch (error) { }
    }
  }

  mainMenuClosed() {
    this.events.publish("hide:balanceSection");

  }

  mainMenuOpened() {
    this.events.publish('menuopen');
    this.sidemenuService.reIterateMenu();
  }

  setupSeoMetaData() {
    //Dynamically Update Route path title and description
    this.seoService.storeSeoMetaData();
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        pluck('urlAfterRedirects'),
        tap((data: string) => this.seoService.updateMeta(data))
      ).subscribe();
  }
}
